<template>
    <div class="form-view password-modal">
        <div v-if="!showFeedback">
            <h2  class="text-center">Glemt adgangskode</h2>
            <div class="form">
                    <div class="grid-x">
                        <div class="banner-lock">
                            <icon class="large-svg fill-white" name="locked" />
                        </div>
                </div>
            </div>
            <h6>
                Hvis du er oprettet som bruger, vil du modtage en e-mail med et nyt kodeord
            </h6>
        </div>
        <section v-if="!showFeedback">
            <div class="form">
                <div class="grid-x">
                    <div class="large-1 medium-1 small-1 cell flexbox-center">
                        <icon class="small-svg fill-dark-gray" name="envelope" />
                    </div>
                    <div class="large-3 medium-3 small-3 cell border-bottom border-bottom-last flexbox align-items">
                        <p class="custom-modal-text-alignment">E-mail</p>
                    </div>
                    <div class="auto cell border-bottom border-bottom-last">
                        <email-validation :newUser="true" :autofocus="true" v-model="data" @validateEmail="validEmailResult" />
                    </div>
                </div>
            </div>
        </section>
        <section v-else class="email-feedback">
            <div class="grid-x" style="height: 450px;">
                <icon class="email-feedback-svg fill-feedback" name="paper-plane" />
            </div>
            <div class="grid-x flexbox-justify-content-center">
                <h3>
                    E-mailen er nu blevet sendt til {{email}}
                </h3>
            </div>
        </section>
        <div class="text-center buttons-modal">
            <a v-if="!showFeedback" @click="changePassword()" :class="{'disabled-button': !validEmail || !email}">Send e-mail</a>
            <a v-if="!showFeedback" @click="closeModal">Fortryd</a>
        </div>
    </div>
</template>

<script>
import { mapActions } from 'vuex'
import emailValidation from './../../shared/email/email-validation.vue'

export default {
    name: 'login-modal-forgotpassword',
    props: [
        'data'
    ],
    data () {
        return {
            email: null,
            validEmail: true,
            showFeedback: false
        }
    },
    components: {
        'email-validation': emailValidation
    },
    methods: {
        ...mapActions({
            setNewPasswordAsync: 'setNewPasswordAsync'
        }),
        closeModal () {
            this.$emit('close')
        },
        changePassword () {
            if (this.validEmail) {
                new Promise((resolve, reject) => {
                    resolve(this.setNewPasswordAsync(this.email))
                }).then((response) => {
                    this.showFeedback = true
                    setTimeout(() => {
                        this.$emit('close')
                    }, 3000)
                })
            }
        },
        validEmailResult (result) {
            this.validEmail = result
        }
    }
}
</script>



// WEBPACK FOOTER //
// src/components/pages/login/login-modal-forgotpassword.vue